module.exports = __webpack_public_path__ + "static/media/dubai_vid_thumb.90226884.gif";